import type { FluxErrorEntityErrorCodes } from '../types.js';

export const TemplateErrorCodes = {
  TemplateAlreadyAttached: {
    code: 'template/already-attached',
    explanation: 'Este template já está anexado a esta etapa e não pode ser anexado novamente.',
    localizations: {},
    message: 'Este template já está anexado a essa etapa.',
    supportingDocs: [
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateAttachExceedsMaxDepth: {
    code: 'template/attach-exceeds-max-depth',
    explanation:
      'Anexar este template excederia a profundidade máxima de aninhamento de templates. Templates podem ser dependentes de outros templates, mas há um limite para evitar complexidade excessiva.',
    localizations: {},
    message:
      'Não é possível anexar o template a outro template, pois o número máximo de níveis foi atingido.',
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  TemplateDuplicateLabels: {
    code: 'template/duplicate-labels',
    explanation:
      'Uma ou mais etiquetas que você está tentando adicionar a este template já existem.',
    localizations: {},
    message: 'Uma ou mais etiquetas já existem no template.',
    supportingDocs: [
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateNotAttached: {
    code: 'template/not-attached',
    explanation: 'Este template não está anexado a esta etapa e não pode ser removido.',
    localizations: {},
    message: 'Este template não está anexado a essa etapa.',
    supportingDocs: [
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
      {
        name: 'Modelos',
        path: '/wiki/docs/pipe/templates/intro',
      },
    ],
  },
  TemplateNotFound: {
    code: 'template/not-found',
    explanation: 'O template que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'Template não encontrado.',
  },
  TemplateTaskCreateFailed: {
    code: 'template/template-task-create-failed',
    explanation:
      'Ocorreu um erro ao tentar criar a tarefa de template. Verifique as informações e tente novamente.',
    localizations: {},
    message: 'Erro ao criar o template.',
  },
  TemplateTaskNotFound: {
    code: 'template/template-task-not-found',
    explanation: 'A tarefa de template que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Template não encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'template'>;

export const TemplateReviewErrorCodes = {
  TemplateReviewDuplicateReviewer: {
    code: 'template-review/duplicate-reviewer',
    explanation:
      'O revisor que você está tentando adicionar a este modelo de revisão já foi adicionado.',
    localizations: {},
    message: 'Este aprovador já foi adicionado à solicitação.',
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
  TemplateReviewExistsInStage: {
    code: 'template-review/exists-in-stage',
    explanation:
      'Este modelo de revisão já está vinculado a esta etapa. Cada etapa só pode vincular o mesmo modelo uma vez.',
    localizations: {},
    message: 'Este modelo de aprovação já está vinculado a esta etapa.',
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
      {
        name: 'Configuração da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  TemplateReviewInvalidReviewerPosition: {
    code: 'template-review/invalid-reviewer-position',
    explanation: 'A posição do revisor no modelo de revisão é inválida.',
    localizations: {},
    message: 'A posição do aprovador é inválida.',
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
  TemplateReviewNotFound: {
    code: 'template-review/not-found',
    explanation: 'O modelo de revisão que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'A solicitação de aprovação não foi encontrada.',
  },
  TemplateReviewRequiredReviewer: {
    code: 'template-review/required-reviewer',
    explanation: 'É necessário adicionar pelo menos um revisor a este modelo de revisão.',
    localizations: {},
    message: 'É necessário adicionar pelo menos um aprovador à solicitação.',
    supportingDocs: [
      {
        name: 'Modelos de Aprovação',
        path: '/wiki/docs/pipe/templates/reviews',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'template-review'>;

export const TemplateDeadlineErrorCodes = {
  TemplateDeadlineNotFound: {
    code: 'template-deadline/not-found',
    explanation: 'O template de prazo que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'O template de prazo não foi encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'template-deadline'>;
